<div [class]="envClass" class="popup-container">
    <mat-toolbar class="custom-toolbar">
        <span class="toolbar-title">{{ event.id && event.id > 0 ? 'Edit Event' : 'New Event' }}</span>
        <span class="fill-empty-space"></span>
        <div class="toolbar-actions">
            <button *ngIf="getSelectedCalendar()"
                mat-icon-button (click)="save()" class="has-tooltip" data-tooltip="Save event">
                <mat-icon>save</mat-icon>
            </button>
            <button
                *ngIf="getSelectedCalendar() && event.id && event.id > 0"
                mat-icon-button (click)="onDelete()" class="has-tooltip" data-tooltip="Delete event">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div class="content-wrapper">
        <!-- Full Width Fields -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Title</mat-label>
            <input matInput name="title" required [(ngModel)]="event.title">
        </mat-form-field>

        <mat-form-field appearance="outline" class="tight-field full-width single-line-field">
            <mat-label>Attendees</mat-label>
            <div class="horizontal-chip-container">
                <mat-chip-grid #chipGrid aria-label="Attendee selection">
                    <mat-chip-row *ngFor="let email of attendees" (removed)="removeAttendee(email)">
                        {{ email }}
                        <button matChipRemove>
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                </mat-chip-grid>
                <input placeholder="Add email..." [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addAttendee($event)"
                    (keydown.enter)="$event.preventDefault()" />
            </div>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tight-field full-width">
            <mat-label>Location</mat-label>
            <input matInput [(ngModel)]="event.location" placeholder="e.g. Room 101 or Teams link">
            <mat-icon matSuffix>location_on</mat-icon>
        </mat-form-field>

        <div class="main-layout">
            <!-- Linkerkolom: Banner + Description Area -->
            <div class="left-column">
                <div class="document-paper">
                    <div class="ck-style-toolbar" *ngIf="editor">
                        <div class="toolbar-group">
                            <button type="button" (click)="editor.chain().focus().toggleBold().run()"
                                [class.active]="editor.isActive('bold')" title="Bold">
                                <mat-icon>format_bold</mat-icon>
                            </button>
                            <button type="button" (click)="editor.chain().focus().toggleItalic().run()"
                                [class.active]="editor.isActive('italic')" title="Italic">
                                <mat-icon>format_italic</mat-icon>
                            </button>
                        </div>

                        <div class="divider"></div>

                        <div class="toolbar-group">
                            <button type="button" (click)="editor.chain().focus().toggleBulletList().run()"
                                [class.active]="editor.isActive('bulletList')" title="Bullet List">
                                <mat-icon>format_list_bulleted</mat-icon>
                            </button>
                            <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()"
                                [class.active]="editor.isActive('orderedList')" title="Numbered List">
                                <mat-icon>format_list_numbered</mat-icon>
                            </button>
                        </div>

                        <div class="divider"></div>

                        <div class="toolbar-group">
                            <button type="button" (click)="editor.chain().focus().undo().run()"
                                [disabled]="!editor.can().undo()" title="Undo">
                                <mat-icon>undo</mat-icon>
                            </button>
                            <button type="button" (click)="editor.chain().focus().redo().run()"
                                [disabled]="!editor.can().redo()" title="Redo">
                                <mat-icon>redo</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div #editorElement class="tiptap-editor-content"></div>
                </div>
            </div>

            <!-- Rechterkolom: Instellingen -->
            <div class="settings-column">
                <mat-form-field appearance="outline" class="tight-field full-width">
                    <mat-label>Calendar</mat-label>
                    <mat-select [(ngModel)]="event.calendarId">
                        <mat-select-trigger>
                            <div class="calendar-option" *ngIf="getSelectedCalendar() as selectedCal">
                                <span class="calendar-color-dot" [style.background-color]="selectedCal.color"></span>
                                <span>{{ getCalendarLabel(selectedCal) }}</span>
                            </div>
                        </mat-select-trigger>
                        <mat-option *ngFor="let cal of calendars" [value]="cal.id">
                            <div class="calendar-option">
                                <span class="calendar-color-dot" [style.background-color]="cal.color"></span>
                                <span>{{ getCalendarLabel(cal) }}</span>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-checkbox [(ngModel)]="isAllDay" class="full-width">All day event</mat-checkbox>

                <div class="recurrence-summary-box" (click)="openRecurrenceDialog()" [matTooltip]="recurrenceSummaryText">
                    <mat-icon>repeat</mat-icon>
                    <span>{{ recurrenceSummaryText || 'Does not repeat' }}</span>
                    <button mat-icon-button type="button" *ngIf="recurrenceSummaryText"
                        (click)="clearRecurrence($event)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <div class="date-time-row">
                    <mat-form-field appearance="outline" class="tight-field flex-grow">
                        <mat-label>Start date</mat-label>
                        <input matInput [matDatepicker]="startPicker" [(ngModel)]="event.startDate">
                        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field *ngIf="!isAllDay" appearance="outline" class="tight-field time-field">
                        <mat-label>Time</mat-label>
                        <input matInput type="text" [(ngModel)]="startTimeStr"
                            (ngModelChange)="onStartTimeChange($event)" [matAutocomplete]="autoStart">
                        <mat-autocomplete #autoStart="matAutocomplete" (opened)="scrollToSelectedTime(startTimeStr)">
                            <mat-option *ngFor="let slot of timeSlots" [value]="slot">
                                {{ slot }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="date-time-row">
                    <mat-form-field appearance="outline" class="tight-field flex-grow">
                        <mat-label>End date</mat-label>
                        <input matInput [matDatepicker]="endPicker" [(ngModel)]="event.endDate">
                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field *ngIf="!isAllDay" appearance="outline" class="tight-field time-field">
                        <mat-label>Time</mat-label>
                        <input matInput type="text" [(ngModel)]="endTimeStr" [matAutocomplete]="autoEnd">
                        <mat-autocomplete #autoEnd="matAutocomplete" (opened)="scrollToSelectedTime(endTimeStr)">
                            <mat-option *ngFor="let slot of timeSlots" [value]="slot">
                                {{ slot }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

            </div>
        </div>
    </div>
</div>